import { Fragment } from "react";
import { Divider, Stack, Typography } from "components";

interface ReceiptItemProps {
  label: string;
  detail: string;
  size?: number;
  labelStyle?: React.CSSProperties;
  detailStyle?: React.CSSProperties;
}

const ReceiptItem: React.FC<ReceiptItemProps> = ({
  label,
  detail,
  size = 0,
  labelStyle,
  detailStyle,
}) => (
  <Stack gap={2}>
    <Typography size={size} color="#AAB4BF" style={labelStyle}>
      {label}
    </Typography>
    <Typography size={size} style={detailStyle}>
      {detail}
    </Typography>
  </Stack>
);

interface ReceiptProps {
  items: string[][][];
  size?: number;
  labelStyle?: React.CSSProperties;
  detailStyle?: React.CSSProperties;
}

const Receipt: React.FC<ReceiptProps> = ({
  items,
  size,
  labelStyle,
  detailStyle,
}) => (
  <Stack direction="column">
    {items.map((row, index) => (
      <Fragment key={index}>
        <div>
          {row.map(([label, detail]) => (
            <ReceiptItem
              key={label}
              label={label}
              detail={detail}
              size={size}
              labelStyle={labelStyle}
              detailStyle={detailStyle}
            />
          ))}
        </div>
        {index < items.length - 1 && <Divider type="dashed" />}
      </Fragment>
    ))}
  </Stack>
);

export { Receipt };
